// Copyright (c) 2020 WiseTime. All rights reserved.

import { TimeRowViewFlag } from "../../../generated/timeline/toolbar/toolbar_pb"

// Check whether the given array contains the specified flag
export const containsFlag = (currentFlags: TimeRowViewFlag[], flag: TimeRowViewFlag): boolean => {
  const foundIndex = currentFlags.findIndex(x => x == flag)
  return foundIndex > -1
}

// Add the given flag to the array if not already present.
export const addViewFlag = (currentFlags: TimeRowViewFlag[], flag: TimeRowViewFlag): void => {
  if (!containsFlag(currentFlags, flag)) {
    currentFlags.push(flag)
  }
}

// Remove the given flag from the array
export const removeViewFlag = (currentFlags: TimeRowViewFlag[], flag: TimeRowViewFlag): void => {
  const foundIndex = currentFlags.findIndex(x => x == flag)
  if (foundIndex > -1) {
    currentFlags.splice(foundIndex, 1)
  }
}
